import { jsx as _jsx } from "react/jsx-runtime";
import { TableHeader } from './header';
import { TableBody } from './body';
import { TableRow } from './row';
import { TableCell } from './cell';
import { TableHead } from './head';
import { TableContainer } from './container';
export function Table({ children }) {
    return (_jsx("table", { className: "w-full text-gray-700 text-sm overflow-hidden", children: children }));
}
Table.Header = TableHeader;
Table.Body = TableBody;
Table.Row = TableRow;
Table.Cell = TableCell;
Table.Head = TableHead;
Table.Container = TableContainer;
